import React, { useEffect, useState } from 'react';
import { CurrencyField, DataTable } from '../../../../commons/DataTable';
import GiveAndTakeLinkField from '../../../../commons/DataTable/GiveAndTakeLinkField';
import { useTranslation } from 'react-i18next';
import { ContAffiliation, H5Styled } from '../../../../styled-components';
import { Col, Row } from 'reactstrap';
import { formatCurrency } from '../../../../lib/helpers/formatters';

function TakeTable({ data, total, offset, limit, onFilter, profile }) {
  const [t] = useTranslation('GIVE_AND_TAKE');
  const [giveData, setGiveData] = useState([]);
  const [allTotalsSum, setAllTotalsSum] = useState(0);

  useEffect(() => {
    const foundedData = data.filter((item) => item.type === 'TAKE');
    setGiveData(foundedData);
    setAllTotalsSum(
      formatCurrency(
        foundedData
          .reduce((sum, item) => sum + (item.allTotals?.total || 0), 0)
          .toFixed(2)
      )
    );
  }, [data]);

  return (
    <>
      <ContAffiliation>
        <Row>
          <Col xs="12">
            <H5Styled>
              {t('TAKE')} - totale competenze attive: {allTotalsSum}
            </H5Styled>
          </Col>
        </Row>
        <br />
        <br />
        <DataTable
          data={giveData}
          total={total}
          offset={offset}
          limit={limit}
          onFilter={onFilter}
          emptyText={t('COMMON:NO_DATA')}
        >
          <CurrencyField
            title="Totale fatture"
            source="totals.invoices"
            tooltip={t('TOTAL_INVOICES_TAKE_TOOLTIP')}
            className="txt-table-right"
            visible={profile?.type === 'SUPPLIER'}
          />
          <CurrencyField
            title="Totale fatture studio"
            source="totals.studioInvoices"
            tooltip={t('TOTAL_INVOICES_STUDIO_TAKE_TOOLTIP')}
            className="txt-table-right"
            visible={[
              'BUILDING_ADMIN_1',
              'BUILDING_ADMIN_2',
              'BUILDING_ADMIN_3',
              'BUILDING_ADMIN_4',
              'BUILDING_ADMIN_5',
            ].includes(profile?.type)}
          />
          <CurrencyField
            title="Totale assicurazioni"
            source="totals.insurances"
            tooltip={t('TOTAL_INSURANCES_TAKE_TOOLTIP')}
            className="txt-table-right"
            visible={profile?.type === 'SUPPLIER_INS'}
          />
          <CurrencyField
            title="Totale energia"
            source="totals.fees"
            tooltip={t('TOTAL_FEES_TAKE_TOOLTIP')}
            className="txt-table-right"
            visible={profile?.type === 'EON_ENERGY'}
          />
          <CurrencyField
            title="Totale energia ricorrente"
            source="totals.recurringFees"
            tooltip={t('TOTAL_RECURRING_FEES_TAKE_TOOLTIP')}
            className="txt-table-right"
            visible={profile?.type === 'EON_ENERGY'}
          />
          <CurrencyField
            title="Totale"
            source="totals.total"
            className="txt-table-right"
          />
          <GiveAndTakeLinkField
            title="Dettagli"
            source="cumulativeFileUrl"
            className="text-left"
          />
        </DataTable>
      </ContAffiliation>
    </>
  );
}

export default TakeTable;
